// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errMsg {
  margin-top: -1.3em;
  font-size: 75%;
}

.dottedLine {
  position: relative;
  padding-bottom: 8px;
  cursor: default;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.42) 0%, rgba(0, 0, 0, 0.42) 33%, transparent 0%);
  background-repeat: repeat-x;
  background-position-y: 24px;
  background-size: 4px 1px;
}

::ng-deep #cardInfoWrapper {
  position: relative;
  color: #212529;
  font-family: "Montserrat", sans-serif;
  font-size: inherit;
  font-weight: 400;
  line-height: 1.125;
}
::ng-deep #cardInfoWrapper:before {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 1px;
  content: "";
  background-color: rgba(0, 0, 0, 0.42);
}
::ng-deep #cardInfoWrapper:focus:before {
  background-color: #2196f3 !important;
}
::ng-deep #cardInfoWrapper:hover:before {
  height: 2px;
  background-color: rgba(0, 0, 0, 0.8);
}
::ng-deep #cardInfoWrapper > div {
  height: 36px;
  box-shadow: none;
}

::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-reflect-float-label=never] .mat-form-field-wrapper .mat-form-field-flex {
  padding: 0.5rem 0.75em 0.5rem 0.75em;
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-reflect-float-label=never] .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix {
  padding: 0.5rem 0.2rem;
  border: 0;
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-reflect-float-label=never] .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-mdc-select {
  display: flex;
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-reflect-float-label=never] .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-mdc-select .mat-select-trigger {
  width: 100%;
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-reflect-float-label=never] .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-mdc-select .mat-select-trigger .mat-select-arrow-wrapper {
  transform: unset;
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-size=small] .mat-form-field-infix {
  padding: 0.25rem 0.5rem;
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-size=medium] .mat-form-field-infix {
  padding: 0.5rem 0.2rem;
}
::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill[ng-size=large] .mat-form-field-infix {
  padding: 1rem;
}

::ng-deep mat-form-field {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field .mat-form-field-wrapper {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-prefix {
  top: 0.15rem;
  padding-right: 0.5rem;
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-suffix {
  top: 0.15rem;
  padding-left: 0.5rem;
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-infix {
  bottom: 0rem;
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-infix .mat-mdc-input-element {
  margin-top: unset;
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-infix .mat-form-field-label-wrapper {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label {
  text-align: left;
}
::ng-deep mat-form-field .mat-form-field-wrapper .mat-form-field-subscript-wrapper .mat-mdc-form-field-error {
  text-align: left;
}

svg:not(:root) {
  position: relative;
}

.strike {
  top: 80%;
  display: block;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}

.strike > span {
  position: relative;
  display: inline-block;
}

.strike > span:before,
.strike > span:after {
  position: absolute;
  top: 78%;
  width: 250px;
  height: 1px;
  content: "";
  background: #2b3761;
}

.strike > span:before {
  right: 70%;
  margin-right: 55px;
}

.strike > span:after {
  left: 70%;
  margin-left: 55px;
}

@media screen and (min-width: 0) and (max-width: 780px) {
  #my-content-1 {
    display: none;
  }
}
@media screen and (min-width: 781px) {
  #my-content-2 {
    display: none;
  }
  .right-content {
    top: 130px;
  }
}
svg {
  min-height: 120px;
}

.fix-min-height {
  min-height: 350px;
}

.pos-bottom {
  position: absolute;
  bottom: 20px;
  width: 100%;
}

.center-pad {
  padding-top: 60px;
  padding-bottom: 70px;
}

.text-label {
  margin-top: 6px;
}

.remove-input-border {
  background-image: none;
  font-size: 16px;
  font-weight: 400;
}

@media screen and (min-width: 0) and (max-width: 952px) {
  .center-pad {
    padding-top: 30px;
  }
}
.no-border {
  border: none;
}

.no-margin-top-bottom {
  margin-top: 0;
  margin-bottom: 0;
}

.textarea {
  white-space: pre-wrap;
}

.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  transition: box-shadow 150ms ease;
  border-radius: 4px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form.checkout {
  margin: 2rem auto;
  padding: 3px;
  text-align: center;
  color: #525252;
  border: 2px solid #eee;
  background-color: #ebf1f7;
  font-family: monospace;
  font-size: 1.1rem;
}

form.checkout button {
  width: 100%;
  padding: 0.5rem 1rem;
  color: white;
  border: none;
  background: rgb(26, 127, 203);
  font-size: 16px;
  font-weight: 500;
}

form.checkout button:active {
  background: rgb(23, 82, 137);
}

label {
  color: #8898aa;
  font-size: 13.5px;
}

#form-field {
  padding: 3px;
  background-color: white !important;
}

#card-info {
  min-width: 400px;
}

mat-error {
  display: flex;
  align-items: center;
  justify-content: center;
}

#card-errors {
  padding: 3px;
  font-size: 13px;
}

.image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  margin-top: 76px;
}

.cards {
  position: relative;
  overflow: hidden;
  height: 55px;
  margin-left: 10px;
  padding: 0 10px;
}

.cards > div {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.cards > div > img {
  margin-right: 20px;
}

#information-message {
  padding: 10px 0;
  color: #67656b;
  font-size: 0.71rem;
}

#submit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  font-weight: 600;
}

#submit-button:hover {
  background-color: rgb(73, 153, 215);
}

#info-icon {
  margin-left: 5px;
}

.cards img {
  width: 55px;
}

@media screen and (max-width: 650px) {
  ::ng-deep .cdk-overlay-pane {
    min-width: 95vw !important;
    max-width: 100% !important;
  }
  ::ng-deep mat-dialog-container {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  form {
    width: 95%;
  }
  form.checkout {
    padding: 1rem 5px !important;
  }
  .image {
    flex-direction: column;
  }
  .cards {
    margin-top: 10px;
  }
  .cards img {
    width: 15%;
  }
  #card-info {
    min-width: 100%;
  }
}
.payment-form {
  animation-name: payment-form;
  animation-duration: 0.4s;
  animation-timing-function: linear;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

@keyframes payment-form {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.payment-methods {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  transition: 0.2s;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.payment-methods:hover {
  background-color: rgba(0, 0, 0, 0.07);
}

.card-details {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 19px;
}

.card-name {
  color: #303238;
  font-size: 19px;
  font-weight: 600;
  font-style: italic;
}

@media only screen and (max-width: 800px) {
  .payment-methods {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/orders/new-order/new-order2/new-order2.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,cAAA;AACD;;AAEA;EACC,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4GAAA;EAMA,2BAAA;EACA,2BAAA;EACA,wBAAA;AAJD;;AAQA;EACC,kBAAA;EACA,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AALD;AAOC;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;AALF;AASE;EACC,oCAAA;AAPH;AAYE;EACC,WAAA;EACA,oCAAA;AAVH;AAcC;EACC,YAAA;EACA,gBAAA;AAZF;;AAiBA;EACC,gIAAA;EACA,gIAAA;EACA,gIAAA;EACA,gIAAA;EAuBA,gIAAA;EAIA,gIAAA;EAIA,gIAAA;AA1CD;AAYC;EACC,oCAAA;EACA,gIAAA;EACA,gIAAA;EACA,gIAAA;AAVF;AAWE;EACC,sBAAA;EACA,SAAA;AATH;AAUG;EACC,aAAA;EACA,4HAAA;EACA,4HAAA;AARJ;AASI;EACC,WAAA;EACA,4HAAA;AAPL;AAQK;EACC,gBAAA;AANN;AAaC;EACC,uBAAA;AAXF;AAcC;EACC,sBAAA;AAZF;AAeC;EACC,aAAA;AAbF;;AAoBA;EACC,gIAAA;EACA,gIAAA;EACA,gIAAA;EACA,gIAAA;AAjBD;AAkBC;EAEC,gIAAA;EAKA,gIAAA;EAKA,gIAAA;EACA,gIAAA;EACA,gIAAA;EAkBA,gIAAA;EACA,gIAAA;AA1CF;AAYE;EACC,YAAA;EACA,qBAAA;AAVH;AAaE;EACC,YAAA;EACA,oBAAA;AAXH;AAgBE;EACC,YAAA;EAMA,gIAAA;EACA,gIAAA;AAnBH;AAcG;EACC,iBAAA;AAZJ;AAiBG;EACC,gIAAA;AAfJ;AAgBI;EACC,gBAAA;AAdL;AAsBG;EACC,gBAAA;AApBJ;;AA0BA;EACC,kBAAA;AAvBD;;AA0BA;EACC,QAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAvBD;;AA0BA;EACC,kBAAA;EACA,qBAAA;AAvBD;;AA0BA;;EAEC,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AAvBD;;AA0BA;EACC,UAAA;EACA,kBAAA;AAvBD;;AA0BA;EACC,SAAA;EACA,iBAAA;AAvBD;;AA0BA;EACC;IACC,aAAA;EAvBA;AACF;AA0BA;EACC;IACC,aAAA;EAxBA;EA0BD;IACC,UAAA;EAxBA;AACF;AA2BA;EACC,iBAAA;AAzBD;;AA4BA;EACC,iBAAA;AAzBD;;AA4BA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;AAzBD;;AA4BA;EACC,iBAAA;EACA,oBAAA;AAzBD;;AA4BA;EACC,eAAA;AAzBD;;AA4BA;EACC,sBAAA;EACA,eAAA;EACA,gBAAA;AAzBD;;AA4BA;EACC;IACC,iBAAA;EAzBA;AACF;AA4BA;EACC,YAAA;AA1BD;;AA6BA;EACC,aAAA;EACA,gBAAA;AA1BD;;AA6BA;EACC,qBAAA;AA1BD;;AA6BA;EACC,sBAAA;EACA,YAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;AA1BD;;AA6BA;EACC,+BAAA;AA1BD;;AA6BA;EACC,qBAAA;AA1BD;;AA6BA;EACC,oCAAA;AA1BD;;AA8BA;EAEC,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AA5BD;;AA+BA;EACC,WAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EAEA,gBAAA;AA7BD;;AAgCA;EACC,4BAAA;AA7BD;;AAgCA;EACC,cAAA;EACA,iBAAA;AA7BD;;AAgCA;EACC,YAAA;EACA,kCAAA;AA7BD;;AAgCA;EACC,gBAAA;AA7BD;;AAgCA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AA7BD;;AAgCA;EACC,YAAA;EACA,eAAA;AA7BD;;AAgCA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA7BD;;AAgCA;EACC,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AA7BD;;AAgCA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7BD;;AAgCA;EACC,kBAAA;AA7BD;;AAgCA;EACC,eAAA;EACA,cAAA;EACA,kBAAA;AA7BD;;AAgCA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA7BD;;AAgCA;EACC,mCAAA;AA7BD;;AAgCA;EACC,gBAAA;AA7BD;;AAgCA;EACC,WAAA;AA7BD;;AAgCA;EACC;IACC,0BAAA;IACA,0BAAA;EA7BA;EAgCD;IACC,6BAAA;IACA,4BAAA;EA9BA;EAiCD;IACC,UAAA;EA/BA;EAkCD;IACC,4BAAA;EAhCA;EAmCD;IACC,sBAAA;EAjCA;EAoCD;IACC,gBAAA;EAlCA;EAqCD;IACC,UAAA;EAnCA;EAsCD;IACC,eAAA;EApCA;AACF;AAwCA;EACC,4BAAA;EACA,wBAAA;EACA,iCAAA;EACA,qBAAA;EAEA,6BAAA;AAvCD;;AA0CA;EACC;IACC,qBAAA;IACA,UAAA;EAvCA;EA0CD;IACC,mBAAA;IACA,UAAA;EAxCA;AACF;AA2CA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;AAzCD;;AA4CA;EACC,qCAAA;AAzCD;;AA4CA;EACC,2DAAA;EACA,eAAA;AAzCD;;AA4CA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAzCD;;AA4CA;EACC;IACC,sBAAA;EAzCA;AACF","sourcesContent":[".errMsg {\n\tmargin-top: -1.3em;\n\tfont-size: 75%;\n}\n\n.dottedLine {\n\tposition: relative;\n\tpadding-bottom: 8px;\n\tcursor: default;\n\tbackground-image: linear-gradient(\n\t\tto right,\n\t\trgba(0, 0, 0, 0.42) 0%,\n\t\trgba(0, 0, 0, 0.42) 33%,\n\t\ttransparent 0%\n\t);\n\tbackground-repeat: repeat-x;\n\tbackground-position-y: 24px;\n\tbackground-size: 4px 1px;\n}\n\n// Styles the stripe input to match the material design filled input variant.\n::ng-deep #cardInfoWrapper {\n\tposition: relative;\n\tcolor: #212529;\n\tfont-family: 'Montserrat', sans-serif;\n\tfont-size: inherit;\n\tfont-weight: 400;\n\tline-height: 1.125;\n\n\t&:before {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\theight: 1px;\n\t\tcontent: '';\n\t\tbackground-color: rgba(0, 0, 0, 0.42);\n\t}\n\n\t&:focus {\n\t\t&:before {\n\t\t\tbackground-color: #2196f3 !important;\n\t\t}\n\t}\n\n\t&:hover {\n\t\t&:before {\n\t\t\theight: 2px;\n\t\t\tbackground-color: rgba(0, 0, 0, 0.8);\n\t\t}\n\t}\n\n\t> div {\n\t\theight: 36px;\n\t\tbox-shadow: none;\n\t}\n}\n\n// SELECT - variant filled - no float label\n::ng-deep mat-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill {\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t&[ng-reflect-float-label='never'] .mat-form-field-wrapper .mat-form-field-flex {\n\t\tpadding: 0.5rem 0.75em 0.5rem 0.75em;\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-infix {\n\t\t\tpadding: 0.5rem 0.2rem;\n\t\t\tborder: 0;\n\t\t\t.mat-mdc-select {\n\t\t\t\tdisplay: flex;\n\t\t\t\t/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n\t\t\t\t/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n\t\t\t\t.mat-select-trigger {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n\t\t\t\t\t.mat-select-arrow-wrapper {\n\t\t\t\t\t\ttransform: unset;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t&[ng-size='small'] .mat-form-field-infix {\n\t\tpadding: 0.25rem 0.5rem;\n\t}\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t&[ng-size='medium'] .mat-form-field-infix {\n\t\tpadding: 0.5rem 0.2rem;\n\t}\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t&[ng-size='large'] .mat-form-field-infix {\n\t\tpadding: 1rem;\n\t}\n}\n\n// Fix material input layout/alignment/positioning.\n// Not sure why float labels and input text alignment is so off, should vert center, horz left.\n// Fixes ‣ input, input prefix/suffix icons, input label, input placeholder, input helper text\n::ng-deep mat-form-field {\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t.mat-form-field-wrapper {\n\t\t// Icons before/after the input\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-prefix {\n\t\t\ttop: 0.15rem;\n\t\t\tpadding-right: 0.5rem;\n\t\t}\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-suffix {\n\t\t\ttop: 0.15rem;\n\t\t\tpadding-left: 0.5rem;\n\t\t}\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-infix {\n\t\t\tbottom: 0rem;\n\t\t\t// Actual input element\n\t\t\t.mat-mdc-input-element {\n\t\t\t\tmargin-top: unset;\n\t\t\t}\n\t\t\t// Actual input label element\n\t\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t\t.mat-form-field-label-wrapper {\n\t\t\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t\t\t.mat-form-field-label {\n\t\t\t\t\ttext-align: left;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// Input helper text\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n\t\t.mat-form-field-subscript-wrapper {\n\t\t\t.mat-mdc-form-field-error {\n\t\t\t\ttext-align: left;\n\t\t\t}\n\t\t}\n\t}\n}\n\nsvg:not(:root) {\n\tposition: relative;\n}\n\n.strike {\n\ttop: 80%;\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-align: center;\n\twhite-space: nowrap;\n}\n\n.strike > span {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.strike > span:before,\n.strike > span:after {\n\tposition: absolute;\n\ttop: 78%;\n\twidth: 250px;\n\theight: 1px;\n\tcontent: '';\n\tbackground: #2b3761;\n}\n\n.strike > span:before {\n\tright: 70%;\n\tmargin-right: 55px;\n}\n\n.strike > span:after {\n\tleft: 70%;\n\tmargin-left: 55px;\n}\n\n@media screen and (min-width: 0) and (max-width: 780px) {\n\t#my-content-1 {\n\t\tdisplay: none;\n\t}\n}\n\n@media screen and (min-width: 781px) {\n\t#my-content-2 {\n\t\tdisplay: none;\n\t}\n\t.right-content {\n\t\ttop: 130px;\n\t}\n}\n\nsvg {\n\tmin-height: 120px;\n}\n\n.fix-min-height {\n\tmin-height: 350px;\n}\n\n.pos-bottom {\n\tposition: absolute;\n\tbottom: 20px;\n\twidth: 100%;\n}\n\n.center-pad {\n\tpadding-top: 60px;\n\tpadding-bottom: 70px;\n}\n\n.text-label {\n\tmargin-top: 6px;\n}\n\n.remove-input-border {\n\tbackground-image: none;\n\tfont-size: 16px;\n\tfont-weight: 400;\n}\n\n@media screen and (min-width: 0) and (max-width: 952px) {\n\t.center-pad {\n\t\tpadding-top: 30px;\n\t}\n}\n\n.no-border {\n\tborder: none;\n}\n\n.no-margin-top-bottom {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}\n\n.textarea {\n\twhite-space: pre-wrap;\n}\n\n.StripeElement {\n\tbox-sizing: border-box;\n\theight: 40px;\n\tpadding: 10px 12px;\n\t-webkit-transition: box-shadow 150ms ease;\n\ttransition: box-shadow 150ms ease;\n\tborder-radius: 4px;\n}\n\n.StripeElement--focus {\n\tbox-shadow: 0 1px 3px 0 #cfd7df;\n}\n\n.StripeElement--invalid {\n\tborder-color: #fa755a;\n}\n\n.StripeElement--webkit-autofill {\n\tbackground-color: #fefde5 !important;\n}\n\n// for stripe form\nform.checkout {\n\t//max-width: 500px;\n\tmargin: 2rem auto;\n\tpadding: 3px;\n\ttext-align: center;\n\tcolor: #525252;\n\tborder: 2px solid #eee;\n\tbackground-color: #ebf1f7;\n\tfont-family: monospace;\n\tfont-size: 1.1rem;\n}\n\nform.checkout button {\n\twidth: 100%;\n\tpadding: 0.5rem 1rem;\n\tcolor: white;\n\tborder: none;\n\tbackground: rgb(26, 127, 203);\n\tfont-size: 16px;\n\t//margin-top: 1rem;\n\tfont-weight: 500;\n}\n\nform.checkout button:active {\n\tbackground: rgb(23, 82, 137);\n}\n\nlabel {\n\tcolor: #8898aa;\n\tfont-size: 13.5px;\n}\n\n#form-field {\n\tpadding: 3px;\n\tbackground-color: white !important;\n}\n\n#card-info {\n\tmin-width: 400px;\n}\n\nmat-error {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n#card-errors {\n\tpadding: 3px;\n\tfont-size: 13px;\n}\n\n.image {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: auto;\n\tmargin-top: 76px;\n}\n\n.cards {\n\tposition: relative;\n\toverflow: hidden;\n\theight: 55px;\n\tmargin-left: 10px;\n\tpadding: 0 10px;\n}\n\n.cards > div {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n}\n\n.cards > div > img {\n\tmargin-right: 20px;\n}\n\n#information-message {\n\tpadding: 10px 0;\n\tcolor: #67656b;\n\tfont-size: 0.71rem;\n}\n\n#submit-button {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\ttransition: 0.2s;\n\tfont-weight: 600;\n}\n\n#submit-button:hover {\n\tbackground-color: rgb(73, 153, 215);\n}\n\n#info-icon {\n\tmargin-left: 5px;\n}\n\n.cards img {\n\twidth: 55px;\n}\n\n@media screen and (max-width: 650px) {\n\t::ng-deep .cdk-overlay-pane {\n\t\tmin-width: 95vw !important;\n\t\tmax-width: 100% !important;\n\t}\n\n\t::ng-deep mat-dialog-container {\n\t\tpadding-right: 4px !important;\n\t\tpadding-left: 4px !important;\n\t}\n\n\tform {\n\t\twidth: 95%;\n\t}\n\n\tform.checkout {\n\t\tpadding: 1rem 5px !important;\n\t}\n\n\t.image {\n\t\tflex-direction: column;\n\t}\n\n\t.cards {\n\t\tmargin-top: 10px;\n\t}\n\n\t.cards img {\n\t\twidth: 15%;\n\t}\n\n\t#card-info {\n\t\tmin-width: 100%;\n\t}\n}\n\n// payment form animation\n.payment-form {\n\tanimation-name: payment-form;\n\tanimation-duration: 0.4s;\n\tanimation-timing-function: linear;\n\tanimation-delay: 0.3s;\n\n\tanimation-fill-mode: forwards;\n}\n\n@keyframes payment-form {\n\t0% {\n\t\ttransform: scale(0.8);\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n}\n\n.payment-methods {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 15px;\n\ttransition: 0.2s;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n}\n\n.payment-methods:hover {\n\tbackground-color: rgba(0, 0, 0, 0.07);\n}\n\n.card-details {\n\tfont-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\tfont-size: 19px;\n}\n\n.card-name {\n\tcolor: #303238;\n\tfont-size: 19px;\n\tfont-weight: 600;\n\tfont-style: italic;\n}\n\n@media only screen and (max-width: 800px) {\n\t.payment-methods {\n\t\tflex-direction: column;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
